import { Injectable } from "@angular/core";
import { CacheFactory, CacheStore, StorageMode } from "@obg/ngx.global";
import { groupBy, head, map as lodashMap, mapValues, unescape } from "lodash-es";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { CommonContentClient } from "../content/common-content.client";
import { CommonContentCache } from "../content/common-content.model";

import { CashDesk, CashDesksByCity, RawCashDesk } from "./cash-desk.model";

@Injectable({
	providedIn: "root",
})
export class CashDeskService {
	private cache: CacheStore;

	constructor(
		private client: CommonContentClient,
		cacheFactory: CacheFactory
	) {
		this.cache = cacheFactory.get(CommonContentCache.CommonCacheStoreKey, {
			isLanguageSpecific: true,
			storageMode: StorageMode.LocalStorage,
		});
	}

	get(): Observable<CashDesksByCity> {
		return this.cache.getOrSetAsObservable(CommonContentCache.CashDeskCacheKey, () =>
			this.client.getCashDesks().pipe(
				map((response) =>
					mapValues(
						groupBy<RawCashDesk>(response.pages, (rawCashDesk) =>
							unescape(head(rawCashDesk.content.textContentItems.city))
						),
						(rawCashDesks) => lodashMap(rawCashDesks, this.processRawCashDesk)
					)
				)
			)
		);
	}

	private processRawCashDesk(rawCashDesk: RawCashDesk): CashDesk {
		return {
			shop: unescape(head(rawCashDesk.content.textContentItems.shop)),
			address: unescape(head(rawCashDesk.content.textContentItems.address)),
			phone: unescape(head(rawCashDesk.content.textContentItems.phone)),
			locationMap: head(rawCashDesk.content.linkContentItems.locationMap),
			openingDays: unescape(head(rawCashDesk.content.textContentItems.openingDays)),
			openingHours: unescape(head(rawCashDesk.content.textContentItems.openingHours)),
		};
	}
}
